export default "__VITE_ASSET__DEqtJkvi__"